"use strict"
import React, {useEffect, useState} from "react"
import {observer} from "mobx-react"
import classnames from "classnames"
import moment from "moment"
import fields from "./fields"
import Countdown from "react-countdown"
import MobxReactForm from "mobx-react-form"
import validatorjs from "validatorjs"
import api from "../../global/actions/api"
import {Container, Grid, Typography, Radio, RadioGroup, FormControlLabel} from "@material-ui/core"
import ReactTooltip from "react-tooltip"
import {injectIntl} from "react-intl"
import XsInput from "../../global/ui/xsInput/xsInput"
import XsAutocomplete from "../../global/ui/xsInput/xsAutocomplete"
import XsNumberInput from "../../global/ui/xsInput/xsNumberInput"
import dvr from "mobx-react-form/lib/validators/DVR"
import AddIcon from "@material-ui/icons/Add"
import GlobalStore from "../../global/store/GlobalStore"
import XsConfirmationDialog from "../../global/ui/xsDialog/xsConfirmationDialog"
import XsButton from "../../global/ui/xsButton/xsButton"
import XsChipForm from "../../global/ui/xsChipForm/xsChipForm"
import XsChip from "../../global/ui/xsChip/xsChip"
import XsIconButton from "../../global/ui/xsButton/xsIconButton"
import RequestFormStore from "./RequestFormStore"
import RouterStore from "../../global/store/RouterStore"
import XsSearchSelect from "../../global/ui/xsSearchSelect/xsSearchSelect"
import XsCheckbox from "../../global/ui/xsCheckbox/xsCheckbox"
import {isIBANValid, isPhoneNumberValid} from "../../global/helpers/functions"
import Dropzone from "react-dropzone"
// import XsTable from "../../global/ui/xsTable/xsTable"
import DeviceDialog from "./DeviceDialog"
import DeviceDialogStore from "./DeviceDialogStore"
import RequestStore from "../requests/requestStore"
import {getUserCompanyInfo} from "../../global/helpers/actions"
import ConsentDialog from "./ConsentDialog"
import ConsentDialogStore from "./ConsentDialogStore"
import WarningDialog from "./WarningDialog"
import WarningDialogStore from "./WarningDialogStore"

function RequestForm(props) {
	const hooks = {
		onSubmit(form) {
			const txt = form.$("status").value === "inp" ? "uložená" : "odoslaná"

			if (form.$("status").value !== "inp") {
				if (DeviceDialogStore.places.length === 0) {
					form.invalidate()
					GlobalStore.setNotificationMessage(`Žiadosť nemôže byť ${txt} bez miesta realizácie projektu!`, null, "error")
				}

				if (
					RequestFormStore.dropedFiles0.length < 1 ||
					RequestFormStore.dropedFiles1.length < 1 ||
					RequestFormStore.dropedFiles2.length < 1 ||
					RequestFormStore.dropedFiles5.length < 1 ||
					(RequestFormStore.dropedFiles4.length < 1 && isNotEmpty(form.$("authorizedPersonName").value))
				) {
					form.$("dropzone").invalidate("minimum")
					GlobalStore.setNotificationMessage(`Žiadosť nemôže byť ${txt} bez prílohy!`, null, "error")
				}

				try {
					let statutars = JSON.parse(form.$("applicantChipForm").value)
					if (
						statutars.some((row) => {
							return isEmpty(row.name)
						})
					) {
						form.$("applicantChipForm").invalidate("minimum")
						GlobalStore.setNotificationMessage(`Žiadosť nemôže byť ${txt} bez štatutára!`, null, "error")
					}
				} catch (e) {
					logger(e)
					GlobalStore.setNotificationMessage(`Žiadosť nemôže byť ${txt} bez štatutára!`, null, "error")
					form.$("applicantChipForm").invalidate("minimum")
				}
			}

			let size = 0

			if (isSafe(RequestFormStore.dropedFiles0[0])) size += RequestFormStore.dropedFiles0[0].size
			if (isSafe(RequestFormStore.dropedFiles1[0])) size += RequestFormStore.dropedFiles1[0].size
			if (isSafe(RequestFormStore.dropedFiles2[0])) size += RequestFormStore.dropedFiles2[0].size
			if (isSafe(RequestFormStore.dropedFiles3[0])) size += RequestFormStore.dropedFiles3[0].size
			if (isSafe(RequestFormStore.dropedFiles4[0])) size += RequestFormStore.dropedFiles4[0].size
			if (isSafe(RequestFormStore.dropedFiles5[0])) size += RequestFormStore.dropedFiles5[0].size
			if (isSafe(RequestFormStore.dropedFiles6[0])) size += RequestFormStore.dropedFiles6[0].size

			if (size > 50000000) {
				form.$("dropzone").invalidate("minimum")
				GlobalStore.setNotificationMessage(`Prekročili ste maximálnu veľkosť všetkých príloh (50MB)!`, null, "error")
			}

			const contactPersonPhone = form.$("contactPersonPhone").value
			if (contactPersonPhone) {
				if (!isPhoneNumberValid(contactPersonPhone)) {
					form.$("contactPersonPhone").invalidate("wrong format")
					GlobalStore.setNotificationMessage("Nesprávny formát telefónneho čísla!", null, "error")
				}
			}
		},
		onSuccess(form) {
			RequestFormStore.generateDataAndSave(form, () => {
				ConsentDialogStore.close(form)
				RouterStore.push("/requests")
				GlobalStore.loading(false)
			})
		},
		onError(form) {
			logger("CHYBY:", form.errors())
			GlobalStore.setNotificationMessage("Skontrolujte povinné polia", null, "error")
		}
	}

	const [form] = useState(new MobxReactForm(fields.load(), {plugins: {dvr: dvr(validatorjs)}, hooks}))
	// const [consortiumRowNumber, setConsortiumRowNumber] = useState(0)

	const initNewForm = async () => {
		const company = getUserCompanyInfo() || {}
		const companyData = await api.companyData(company.company_id).call()

		if (RequestStore.data.length === 0) {
			RequestStore.getRequests()
		}

		form.$("companyName").value = companyData.name
		form.$("ico").value = companyData.identifier

		form.$("dic").value = isNotEmpty(companyData.tax_identification_number)
			? companyData.tax_identification_number
			: null
		form.$("icdph").value = isNotEmpty(companyData.vat_identification_number)
			? companyData.vat_identification_number
			: null
		form.$("companyIBAN").value = isNotEmpty(companyData.iban) ? companyData.iban : null
		form.$("companyLegalForm").value = isNotEmpty(companyData.legal_form_id) ? companyData.legal_form_id : null
		form.$("companySize").value = isNotEmpty(companyData.company_size_id) ? companyData.company_size_id : null
		form.$("skNace").value = isNotEmpty(companyData.classification_id) ? companyData.classification_id : null
		form.$("companyCity").value = isNotEmpty(companyData.city_id) ? companyData.city_id : null
		form.$("companyStreet").value = isNotEmpty(companyData.street_plain) ? companyData.street_plain : null
		form.$("companySWIFT").value = isNotEmpty(companyData.swift) ? companyData.swift : null

		form.$("communicationMethod").value = getUserCompanyInfo().communication_method
			? "electronicCommunication"
			: "writtenCommunication"

		RequestFormStore.showSwift = isNotEmpty(companyData.swift) ? true : false

		// form.$("companyName").value = "Slovenská inovačná a energetická agentúra"
		// form.$("dic").value = "2020877749"
		// form.$("icdph").value = "SK2020877749"
		// form.$("ico").value = "00002801"
		// form.$("companyIBAN").value = "SK6217564752187124991713"
		// form.$("companyLegalForm").value = "neziskovaOrg"
		// form.$("companySize").value = "pravnickaOsoba"
		// form.$("skNace").value = "503"
		// form.$("companyCity").value = "SK0315510611"
		// form.$("companyStreet").value = "Hlavna 1"
		// form.$("contactPersonName").value = "Ferko Urban"
		// form.$("contactPersonPhone").value = "+421944549778"
		// form.$("contactPersonMail").value = "ferko@gmail.com"
		// form.$("authorizedPersonName").value = "Karel Chlo"
		// form.$("authorizedPersonPhone").value = "+421944549111"
		// form.$("authorizedPersonMail").value = "karel@gmail.com"

		// DeviceDialogStore.places = [
		// 	{
		// 		cityId: "SK0422598119",
		// 		city: "values.cityName",
		// 		street: "Hotentovo 13",
		// 		devices: [
		// 			{
		// 				_id: "2323-23-23-23-23-23-23",
		// 				deviceId: "5",
		// 				device: "values.deviceName",
		// 				deviceCode: "HPWA",
		// 				power: "4"
		// 			}
		// 		]
		// 	}
		// ]
		DeviceDialogStore.places = []
		RequestFormStore.defaultFormValues = form.values()
	}

	useEffect(() => {
		RequestFormStore.formRef = form
		RequestFormStore.resetDropzones()
		RequestFormStore.getRounds()

		if (isNotEmpty(props.id)) {
			RequestFormStore.loadCodelistAndForm(form, props.id)
			RequestFormStore.readonlyForm = true
		} else {
			initNewForm()
			RequestFormStore.readonlyForm = false
		}
	}, [])

	const handleDrop = (files, index, length, templateName) => {
		for (let fileIndex in files) {
			let file = files[fileIndex]

			if (file.size > 52428800) {
				GlobalStore.setNotificationMessage("Súbor je príliš veľký!", null, "error")
				continue
			}
			if (RequestFormStore[`dropedFiles${index}`].length >= length) {
				GlobalStore.setNotificationMessage("Bol prekročený maximálny počet súborov!", null, "error")
				continue
			}

			if (index != "Other") {
				if (index == 0) {
					file.databaseType = "priceComparison"
				}
			} else {
				file.databaseType = "General"
			}
			file.templateName = templateName
			RequestFormStore[`dropedFiles${index}`].push(file)
		}
	}

	// const handleDropzonePreview = (attachmentIndex, dropzoneIndex) => {
	// 	var FileSaver = require("file-saver") // eslint-disable-line no-undef
	// 	FileSaver.saveAs(
	// 		RequestFormStore[`dropedFiles${dropzoneIndex}`][attachmentIndex],
	// 		RequestFormStore[`dropedFiles${dropzoneIndex}`][attachmentIndex].name
	// 	)
	// }

	const handleDropzoneDelete = (attachmentIndex, dropzoneIndex, template) => {
		// if (isSafe(RequestFormStore[`dropedFiles${dropzoneIndex}`][attachmentIndex]._id)) {
		// 	RequestFormStore.deleteLoadedAttachemnt(
		// 		RequestFormStore[`dropedFiles${dropzoneIndex}`][attachmentIndex]._id,
		// 		dropzoneIndex,
		// 		attachmentIndex
		// 	)
		// } else {
		RequestFormStore[`dropedFiles${dropzoneIndex}`].splice(attachmentIndex, 1)
		// }

		if (template === "GD:GDREQ:POWEROFATTORNEY") {
			form.$("authorizedPersonName").set("rules", "")
		}
	}

	const isFormDisabled = () => {
		return RequestFormStore.readonlyForm
	}

	const isAllowOwners = () => {
		return form.$("companyLegalForm").value === "druzstvo" || form.$("companyLegalForm").value === "as"
	}

	return (
		<React.Fragment>
			<Container maxWidth="lg">
				<Container maxWidth="lg" className="request_form_fields">
					{isNotEmpty(form.$("status").value) && (
						<Grid container spacing={3} className="pt-4">
							<Grid item>
								<Typography variant="h6" style={{fontWeight: "normal"}}>
									Štart kola výzvy:{" "}
								</Typography>
							</Grid>
							<Grid item>
								<Typography variant="h6">
									{isNotEmpty(form.$("start").value) ? moment(form.$("start").value).format("DD.MM.YYYY HH:mm") : ""}
								</Typography>
							</Grid>
						</Grid>
					)}
					{form.$("status").value === "inp" && (
						<Grid container spacing={3}>
							<Grid item>
								<Typography variant="h6" style={{fontWeight: "normal"}}>
									Do štartu kola výzvy zostáva:
								</Typography>
							</Grid>
							<Grid item>
								{isNotEmpty(form.$("startBy").value) && (
									<Countdown
										date={moment() + form.$("startBy").value}
										renderer={({days, hours, minutes, seconds, completed}) => {
											if (completed) {
												return (
													<Grid container spacing={2} wrap="nowrap">
														<Grid item container spacing={1} wrap="nowrap">
															<Grid item>
																<Typography variant="h6">0</Typography>
															</Grid>
															<Grid item>
																<Typography variant="h6" style={{fontWeight: "normal"}}>
																	dní
																</Typography>
															</Grid>
														</Grid>
														<Grid item container spacing={1} wrap="nowrap">
															<Grid item>
																<Typography variant="h6">0</Typography>
															</Grid>
															<Grid item>
																<Typography variant="h6" style={{fontWeight: "normal"}}>
																	hodín
																</Typography>
															</Grid>
														</Grid>
														<Grid item container spacing={1} wrap="nowrap">
															<Grid item>
																<Typography variant="h6">0</Typography>
															</Grid>
															<Grid item>
																<Typography variant="h6" style={{fontWeight: "normal"}}>
																	minút
																</Typography>
															</Grid>
														</Grid>
														<Grid item container spacing={1} wrap="nowrap">
															<Grid item>
																<Typography variant="h6">0</Typography>
															</Grid>
															<Grid item>
																<Typography variant="h6" style={{fontWeight: "normal"}}>
																	sekúnd
																</Typography>
															</Grid>
														</Grid>
													</Grid>
												)
											}
											return (
												<Grid container spacing={2} wrap="nowrap">
													<Grid item container spacing={1} wrap="nowrap">
														<Grid item>
															<Typography variant="h6">{days}</Typography>
														</Grid>
														<Grid item>
															<Typography variant="h6" style={{fontWeight: "normal"}}>
																{days === 1 ? "deň" : "dní"}
															</Typography>
														</Grid>
													</Grid>
													<Grid item container spacing={1} wrap="nowrap">
														<Grid item>
															<Typography variant="h6">{hours}</Typography>
														</Grid>
														<Grid item>
															<Typography variant="h6" style={{fontWeight: "normal"}}>
																{hours === 1 ? "hodina" : hours > 1 && hours < 5 ? "hodiny" : "hodín"}
															</Typography>
														</Grid>
													</Grid>
													<Grid item container spacing={1} wrap="nowrap">
														<Grid item>
															<Typography variant="h6">{minutes}</Typography>
														</Grid>
														<Grid item>
															<Typography variant="h6" style={{fontWeight: "normal"}}>
																{minutes === 1 ? "minuta" : minutes > 1 && minutes < 5 ? "minúty" : "minút"}
															</Typography>
														</Grid>
													</Grid>
													<Grid item container spacing={1} wrap="nowrap">
														<Grid item>
															<Typography variant="h6">{seconds}</Typography>
														</Grid>
														<Grid item>
															<Typography variant="h6" style={{fontWeight: "normal"}}>
																{seconds === 1 ? "sekunda" : seconds > 1 && seconds < 5 ? "sekundy" : "sekúnd"}
															</Typography>
														</Grid>
													</Grid>
												</Grid>
											)
										}}
									/>
								)}
							</Grid>
						</Grid>
					)}
					<Grid container spacing={2} className="pt-4">
						<Grid item xs={12}>
							<Typography variant="h4">Žiadosť o vydanie poukážky {form.$("gd_request_id").value || ""}</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="body1" className="mb-3 bold">
								Upraviť žiadosť o vydanie poukážky je možné kedykoľvek až do jej odoslania.
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="h5">1. Údaje o žiadateľovi</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="body2">Polia označené * sú povinné.</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="body1" className="bold">
								Identifikácia žiadateľa
							</Typography>
						</Grid>

						<Grid item xs={12} md={6} lg={4}>
							<XsInput field={form.$("companyName")} disabled />
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsNumberInput field={form.$("ico")} disabled step={"1"} min={"1"} />
						</Grid>
						<Grid item xs={12} md={6} lg={4}>
							<XsSearchSelect
								field={form.$("companyLegalForm")}
								disabled={isFormDisabled()}
								items={GlobalStore.CL["legalForm"]}
							/>
						</Grid>

						<Grid item xs={12} md={4}>
							<XsAutocomplete
								field={form.$("companyCity")}
								minLengthForSearch="1"
								api={api.loadEntityCity}
								inputRenderer={(obj) => obj.city_county}
								saveValue={(obj) => obj.code}
								disabled={isFormDisabled()}
							/>
						</Grid>
						<Grid item xs={12} md={4}>
							<XsInput field={form.$("companyStreet")} disabled={isFormDisabled()} />
						</Grid>

						<Grid item container spacing={2}>
							<Grid item xs={12} md={6} lg={4}>
								<XsInput
									field={form.$("companyIBAN")}
									disabled={isFormDisabled()}
									onBlur={(field) => {
										if (isIBANValid(field.value)) {
											const code = field.value.substring(0, 2)

											RequestFormStore.showSwift = code !== "SK" ? true : false
										} else {
											form.$("companySWIFT").value = ""
											RequestFormStore.showSwift = false
										}
									}}
								/>
							</Grid>
							{RequestFormStore.showSwift && (
								<Grid item xs={12} md={6} lg={4}>
									<XsInput field={form.$("companySWIFT")} disabled={isFormDisabled()} />
								</Grid>
							)}
							<Grid item xs={12} md={6} lg={2}>
								<XsNumberInput field={form.$("dic")} step={"1"} min={"1"} disabled={isFormDisabled()} />
							</Grid>
							<Grid item xs={12} md={6} lg={2} data-tip data-for="icDphTooltip">
								<XsInput field={form.$("icdph")} disabled={isFormDisabled()} />
								<ReactTooltip className="custom-tooltip-line-height" id="icDphTooltip">
									V prípade, že nie ste platiteľom DPH, uveďte do poľa číslo 0
								</ReactTooltip>
							</Grid>
						</Grid>

						<Grid item xs={12} md={6} lg={3}>
							<XsSearchSelect
								field={form.$("companySize")}
								disabled={isFormDisabled()}
								items={GlobalStore.CL["companySize"]}
							/>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsSearchSelect
								field={form.$("skNace")}
								disabled={isFormDisabled()}
								items={GlobalStore.CL["skNace"]}
								onChange={(obj) => logger(obj)}
							/>
						</Grid>
					</Grid>
					{isAllowOwners() && (
						<Grid item container spacing={2} className="mt-4">
							<Grid item xs={12}>
								<Typography variant="body1" className="bold">
									Vlastníci žiadateľa
								</Typography>
							</Grid>
							<Grid item container spacing={2} className="mt-4" alignItems="center">
								<Grid item xs={12} md={6} lg={5}>
									Počet vlastníkov žiadateľa s vlastníckym podielom nad 5%:
								</Grid>
								<Grid item xs={12} md={4} lg={3}>
									<XsNumberInput
										field={form.$("numberOfOwners")}
										disabled={isFormDisabled()}
										onChange={(val) => {
											for (let i = 1; i <= 20; i++) {
												if (i <= val) {
													form.$(`rpo_search_${i}`).set("rules", "required")
													form.$(`ownerName_${i}`).set("rules", "")
													form.$(`ownershipInterest_${i}`).set("rules", "required")
												} else {
													form.$(`rpo_search_${i}`).set("rules", "")
													form.$(`ownerName_${i}`).set("rules", "")
													form.$(`ownershipInterest_${i}`).set("rules", "")
												}
											}
										}}
										step={"1"}
										min={"0"}
										max={"20"}
									/>
								</Grid>
							</Grid>
							{form.$("numberOfOwners").value <= 20 &&
								Array.from({length: Math.max(0, form.$("numberOfOwners").value || 0)}, (_, i) => i + 1).map(
									(ownerIndex) => (
										<Grid item container spacing={2} className="mt-2" alignItems="center" key={`owner_${ownerIndex}`}>
											<Grid item xs={12} md={5}>
												<RadioGroup
													row
													value={form.$(`ownerType_${ownerIndex}`).value}
													onChange={(e) => {
														form.$(`ownerType_${ownerIndex}`).value = e.target.value
														if (e.target.value === "naturalPerson") {
															form.$(`rpo_search_${ownerIndex}`).set("rules", "")
															form.$(`ownerName_${ownerIndex}`).set("rules", "required")
														} else {
															form.$(`rpo_search_${ownerIndex}`).set("rules", "required")
															form.$(`ownerName_${ownerIndex}`).set("rules", "")
														}
													}}
												>
													<FormControlLabel
														value="legalEntity"
														control={<Radio disabled={isFormDisabled()} />}
														label="Právnická osoba"
														disabled={isFormDisabled()}
													/>
													<FormControlLabel
														value="naturalPerson"
														control={<Radio disabled={isFormDisabled()} />}
														label="Fyzická osoba"
														disabled={isFormDisabled()}
													/>
												</RadioGroup>
											</Grid>
											<Grid item xs={12} md={4} lg={4}>
												{form.$(`ownerType_${ownerIndex}`).value === "naturalPerson" ? (
													<XsInput field={form.$(`ownerName_${ownerIndex}`)} disabled={isFormDisabled()} />
												) : (
													<XsAutocomplete
														field={form.$(`rpo_search_${ownerIndex}`)}
														minLengthForSearch="3"
														api={api.rpoSearch}
														inputRenderer={(obj) => `${obj.name} ${obj.identifier}`}
														postAction={(obj) => {
															form.$(`rpo_search_name_${ownerIndex}`).value = obj.name
														}}
														onClear={() => {
															form.$(`rpo_search_name_${ownerIndex}`).value = ""
														}}
														saveValue={(obj) => obj.identifier}
														searchFilter={"search"}
														rowCountFull={10}
													/>
												)}
											</Grid>
											<Grid item xs={12} md={3} lg={2}>
												<XsNumberInput
													field={form.$(`ownershipInterest_${ownerIndex}`)}
													disabled={isFormDisabled()}
													step={"0.01"}
													min={"5"}
													max={"100"}
												/>
											</Grid>
										</Grid>
									)
								)}
						</Grid>
					)}
					<Grid container spacing={2} className="mt-4">
						<Grid item xs={12}>
							<Typography variant="body1" className="bold">
								Spôsob komunikácie
							</Typography>
						</Grid>
						<Grid item xs={12} className="mb-2">
							<Typography variant="body1">
								<RadioGroup
									row
									value={form.$(`communicationMethod`).value}
									onChange={(e) => {
										form.$(`communicationMethod`).value = e.target.value
									}}
								>
									<FormControlLabel
										value="writtenCommunication"
										control={<Radio disabled={isFormDisabled()} />}
										label="Listová forma"
										disabled={isFormDisabled()}
									/>
									<FormControlLabel
										value="electronicCommunication"
										control={<Radio disabled={isFormDisabled()} />}
										label="Elektronická forma"
										disabled={isFormDisabled()}
									/>
								</RadioGroup>
								{/* {getUserCompanyInfo().communication_method
									? "Počas registrácie ste si zvolili elektronickú formu komunikácie prostredníctvom schránky na portáli slovensko.sk."
									: "Počas registrácie ste si zvolili listovú formu komunikácie."} */}
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="body1" className="bold mt-1">
								Štatutárny orgán žiadateľa / Fyzická osoba oprávnená konať v mene MSP
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="body2">
								V prípade viacerých členov štatutárneho orgánu ich pridáte pomocou kliknutia na znamienko +
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<XsChipForm
								field={form.$("applicantChipForm")}
								label={" "}
								configuration={{
									header: {
										chipsRenderer: (key, dataRow, clickHandler) => (
											<XsChip
												key={key}
												label={
													isSafe(dataRow["name"]) && isNotEmpty(dataRow["name"]["value"])
														? dataRow["name"]["value"]
														: ""
												}
												onClick={(e) => clickHandler(false, e, key)}
											/>
										),
										addButtonRenderer: (clickHandler) => (
											<XsIconButton className="xs-default xs-outline" icon={<AddIcon />} onClick={clickHandler} />
										)
									},
									columns: [
										{
											name: "name",
											label: "Priezvisko, Meno, Titul pred, Titul za",
											width: 7,
											validationRule: "required",
											renderer: (field) => <XsInput field={field} disabled={isFormDisabled()} forceRequired />
										}
									],
									options: {
										disabled: isFormDisabled(),
										disableFirstRowDelete: true,
										isFormMode: true,
										isModalMode: false,
										hideButtons: true,
										startOpen: true,
										maxLength: 5,
										hideHeader: true,
										onFormOpen: () => {},
										onFormClose: () => {},
										onFormSave: (vals) => {
											RequestFormStore.locationChipForm = vals
										}
									},
									data: RequestFormStore.locationChipForm
								}}
							/>
						</Grid>

						<Grid item xs={12}>
							<Typography variant="body1" className="bold">
								Kontaktná osoba žiadateľa
							</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="body2" className="mb-2">
								Upozorňujeme, aby ste kontaktnú osobu zadali uvážene, keďže na jej e-mailovú adresu budú zasielané výzvy
								a oznámenia v rámci procesu posudzovania žiadosti podľa článku R, bod 12 Všeobecných podmienok.
							</Typography>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsInput field={form.$("contactPersonName")} disabled={isFormDisabled()} />
						</Grid>
						<Grid item xs={12} md={6} lg={3} data-tip data-for="contactPersonPhoneTooltip">
							<XsInput
								field={form.$("contactPersonPhone")}
								disabled={isFormDisabled()}
								regex={(val) => isPhoneNumberValid(val)}
							/>
							<ReactTooltip className="custom-tooltip-line-height" id="contactPersonPhoneTooltip">
								Telefónne číslo zadávajte bez medzier.
							</ReactTooltip>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsInput field={form.$("contactPersonMail")} disabled={isFormDisabled()} />
						</Grid>

						<Grid item xs={12}>
							<Typography variant="body1" className="bold">
								Splnomocnená osoba (ak relevantné)
							</Typography>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsInput
								field={form.$("authorizedPersonName")}
								disabled={isFormDisabled()}
								onBlur={(e) => {
									if (isNotEmpty(e.value) && RequestFormStore.dropedFiles4.length < 1) {
										GlobalStore.setNotificationMessage(
											"Je potrebné vložiť Prílohu č.5 – Plnomocenstvo",
											null,
											"warning"
										)
									}
								}}
							/>
						</Grid>
						<Grid item xs={12} md={6} lg={3} data-tip data-for="authorizedPersonPhoneTooltip">
							<XsInput
								field={form.$("authorizedPersonPhone")}
								disabled={isFormDisabled()}
								regex={(val) => isPhoneNumberValid(val) || isEmpty(val)}
							/>
							<ReactTooltip className="custom-tooltip-line-height" id="authorizedPersonPhoneTooltip">
								Telefónne číslo zadávajte bez medzier.
							</ReactTooltip>
						</Grid>
						<Grid item xs={12} md={6} lg={3}>
							<XsInput field={form.$("authorizedPersonMail")} disabled={isFormDisabled()} />
						</Grid>

						<Grid item xs={12}>
							<Typography variant="h5">2. Údaje o projekte</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="body2">Polia označené * sú povinné.</Typography>
						</Grid>

						<Grid item xs={12} md={6} lg={4}>
							{isFormDisabled() ? (
								<XsInput field={form.$("round_text")} disabled />
							) : (
								<XsSearchSelect
									field={form.$("round_id")}
									disabled={isFormDisabled() || DeviceDialogStore.places.length > 0}
									items={RequestFormStore.roundsData}
									onChange={(obj) => (form.$("region_type_id").value = obj.region_type_id)}
								/>
							)}
						</Grid>

						{DeviceDialogStore.places.length > 0 && (
							<React.Fragment>
								<Grid item xs={12} className="redDanger">
									Po uložení žiadosti už nie je možné zmeniť kolo výzvy.
								</Grid>
								<Grid item xs={12} className="pt-0">
									Ak ste omylom vytvorili a uložili žiadosť do nesprávneho kola výzvy, je potrebné vytvoriť novú
									žiadosť.
								</Grid>
							</React.Fragment>
						)}

						<Grid item container className="mb-2 mt-2" justify="space-between" alignItems="center">
							<Grid>
								<Typography variant="body1" className="bold">
									Miesto realizácie projektu
								</Typography>
							</Grid>
							<Grid>
								<XsButton
									icon={<i className="fal fa-plus"></i>}
									onClick={() => {
										DeviceDialogStore.open()
									}}
									disabled={isFormDisabled() || isEmpty(form.$("round_id").value)}
									text="PRIDAŤ MIESTO REALIZÁCIE PROJEKTU"
								/>
							</Grid>
						</Grid>

						<Grid item xs={12} className="mb-4" style={{border: "3px solid lightgrey", borderRadius: 5}}>
							<Grid container className="bold pt-1 pb-1">
								<Grid item xs={2}>
									Obec
								</Grid>
								<Grid item xs={2}>
									Ulica
								</Grid>
								<Grid container item xs className="pb-2" spacing={2}>
									<Grid item xs={4}>
										Zariadenie
									</Grid>
									<Grid item xs={2} style={{textAlign: "right"}}>
										Výkon
									</Grid>
									<Grid item xs={2} style={{textAlign: "right"}}>
										Kapacita
									</Grid>
									<Grid item xs={2}>
										K. ú.
									</Grid>
									<Grid item xs={2}>
										Číslo parcely
									</Grid>
								</Grid>
								<Grid item style={{width: "50px"}}>
									&nbsp;
								</Grid>
							</Grid>
							{DeviceDialogStore.places.map((place) => {
								return (
									<React.Fragment key={place.cityId}>
										<Grid container className="pa-2 bgGreyLight" alignItems="center" style={{borderRadius: 5}}>
											<Grid item xs={2}>
												{place.city}
											</Grid>
											<Grid item xs={2}>
												{place.street}
											</Grid>
											<Grid item container xs justify="flex-end" spacing={2}>
												<Grid item>
													<XsButton
														className="xs-success xs-outline"
														icon={<i className="fal fa-plus fa-lg"></i>}
														text="PRIDAŤ ĎALŠIE ZARIADENIE"
														disabled={isFormDisabled()}
														onClick={() => {
															DeviceDialogStore.open(place)
														}}
													/>
												</Grid>
												<Grid item>
													<XsButton
														className="xs-danger xs-outline"
														icon={<i className="fal fa-times fa-lg"></i>}
														text="ODSTRÁNIŤ MIESTO"
														disabled={isFormDisabled()}
														onClick={() => {
															DeviceDialogStore.removePlace(place)
														}}
													/>
												</Grid>
											</Grid>
										</Grid>
										{place.devices.map((device) => {
											return (
												<Grid container className="pt-2 pb-2" key={`${place.cityId}_${device._id}`}>
													<Grid item xs={2}>
														&nbsp;
													</Grid>
													<Grid item xs={2}>
														&nbsp;
													</Grid>
													<Grid container item xs>
														<Grid container item xs={12} spacing={2} className="pb-2 pt-2">
															<Grid item xs={4}>
																{device.device}
															</Grid>
															<Grid item xs={2} style={{textAlign: "right"}}>
																{device.power &&
																	Number(device.power)
																		.toFixed(3)
																		.replace(".", ",")}
															</Grid>
															<Grid item xs={2} style={{textAlign: "right"}}>
																{device.capacity &&
																	Number(device.capacity)
																		.toFixed(3)
																		.replace(".", ",")}
															</Grid>
															<Grid item xs={2}>
																{device.catastral}
															</Grid>
															<Grid item xs={2}>
																{device.parcel}
															</Grid>
														</Grid>
													</Grid>
													<Grid item container style={{width: "50px"}} justify="flex-end">
														<Grid item>
															{place.devices.length > 1 && (
																<XsIconButton
																	className="xs-danger xs-outline"
																	icon={<i className="fal fa-times fa-lg"></i>}
																	disabled={isFormDisabled()}
																	onClick={() => {
																		DeviceDialogStore.removeDevice(place, device)
																	}}
																/>
															)}
														</Grid>
													</Grid>
												</Grid>
											)
										})}
									</React.Fragment>
								)
							})}
						</Grid>

						<Grid item xs={12}>
							<XsCheckbox
								field={form.$("contributionForEnergyAudit")}
								labelVariant="button"
								disabled={isFormDisabled()}
								onChange={() => DeviceDialogStore.getAssumedValue()}
							/>
						</Grid>

						<Grid item xs={12}>
							<Typography variant="h5">3. Prílohy</Typography>
						</Grid>
						<Grid item xs={12}>
							<Typography variant="body2">
								Polia označené * sú povinné. Do každého poľa je možné vložiť len jeden súbor. Povolené typy príloh:
								.pdf, .xls, .xlsx, .odf, .ods, .odt. Maximálna veľkosť všetkých príloh spolu je 50 MB.
							</Typography>
						</Grid>

						<Grid item container>
							{isSafe(RequestFormStore.attachmentTemplates) &&
								RequestFormStore.attachmentTemplates.map((template, dropzoneIndex) => {
									return (
										<Grid item container spacing={2} key={dropzoneIndex}>
											<Grid item xs={12}>
												{template === "GD:GDREQ:ENERGETICAUDIT" && (
													<Typography variant="body1" className="bold">
														Príloha č.1 – Energetický audit *
													</Typography>
												)}
												{template === "GD:GDREQ:OZE" && (
													<Typography variant="body1" className="bold">
														Príloha č.2 – Súbor údajov pre monitorovanie OZE *
													</Typography>
												)}
												{template === "GD:GDREQ:MINIMALDECLARATION" && (
													<Typography variant="body1" className="bold">
														Príloha č.3 – Vyhlásenie žiadateľa o minimálnu pomoc *
													</Typography>
												)}
												{template === "GD:GDREQ:DIVISIONACTIVITY" && (
													<Typography variant="body1">
														Príloha č.4 – Doklady preukazujúce oddelenie činností, resp. oddelenie účtovníctva (ak
														relevantné)
													</Typography>
												)}
												{template === "GD:GDREQ:POWEROFATTORNEY" && (
													<Typography
														variant="body1"
														className={classnames({bold: isNotEmpty(form.$("authorizedPersonName").value)})}
													>
														Príloha č.5 – Plnomocenstvo (ak relevantné){" "}
														{isNotEmpty(form.$("authorizedPersonName").value) && "*"}
													</Typography>
												)}
												{template === "GD:GDREQ:AFFIDAVIT" && (
													<Typography variant="body1" className="bold">
														Príloha č.6 – Čestné vyhlásenie *
													</Typography>
												)}
											</Grid>
											<Grid item xs={12}>
												<Dropzone
													onDrop={(files) => {
														handleDrop(files, dropzoneIndex, 1, template)
														if (template === "GD:GDREQ:POWEROFATTORNEY") {
															form.$("authorizedPersonName").set("rules", "required")
															if (isEmpty(form.$("authorizedPersonName").value)) {
																GlobalStore.setNotificationMessage(
																	"Je potrebné vyplniť splnomocnenú osobu",
																	null,
																	"warning"
																)
															}
														}
													}}
													id="dropzone"
													disabled={isFormDisabled()}
													accept={[".pdf", ".xls", ".xlsx", ".odf", ".ods", ".odt"]}
												>
													{isSafe(RequestFormStore[`dropedFiles${dropzoneIndex}`]) &&
													RequestFormStore[`dropedFiles${dropzoneIndex}`].length ? (
														RequestFormStore[`dropedFiles${dropzoneIndex}`].map((file, index) => (
															<div key={index} className={"dropedFile"}>
																<i
																	className="fal fa-file icon"
																	onClick={(e) => {
																		e.stopPropagation()

																		if (file._id) {
																			api
																				.downloadFile(
																					`/object/attachment/${file._id}/redirect`,
																					file.name || "file.pdf"
																				)
																				.call()
																		}
																	}}
																/>
																<i
																	className="far fa-trash-alt deleteIcon"
																	onClick={(e) => {
																		e.stopPropagation()
																		if (!isFormDisabled()) {
																			GlobalStore.openConfirmationDialog("xsDeleteAttachmentFromDropzone", {
																				fileIndex: index,
																				dropzoneIndex: dropzoneIndex,
																				template: template
																			})
																		}
																	}}
																/>
																<br />
																<div
																	className={"mac_ellipsis"}
																	data-content-start={file.name.substr(0, Math.floor(file.name.length / 2))}
																	data-content-end={
																		"\u200E" + file.name.substr(Math.floor(file.name.length / 2)) + "\u200E"
																	}
																/>
															</div>
														))
													) : (
														<div
															className={"dropzonePlaceholder"}
														>{`Nahrajte súbor jeho potiahnutím (drag and drop) alebo kliknite a vyberte z Vášho súborového systému`}</div>
													)}
												</Dropzone>
											</Grid>
										</Grid>
									)
								})}
						</Grid>
					</Grid>

					<Grid container className="mt-8">
						<Typography variant="h5">4. Predpokladaná hodnota poukážky</Typography>
						<Typography variant="body2" className="redDanger mt-2">
							Upozorňujeme, že suma zobrazená v systéme je orientačná a predstavuje maximálnu možnú výšku poukážky.
							Skutočná suma poukážky uvedená v oznámení o schválení sa môže líšiť, keďže sa určuje podľa reálnych údajov
							o platcovstve DPH, priznaného percenta pomoci, výsledkov energetického auditu, resp. iných skutočností.
						</Typography>
					</Grid>

					<Grid container className="mt-8" justify="center">
						<Grid item xs={12} md={6} lg={4} style={{border: "1px solid #CED7D9", borderRadius: 5}}>
							<Typography variant="h3" className="textCenter pt-1 pb-1">
								{new Intl.NumberFormat("sk-SK", {style: "currency", currency: "EUR"}).format(
									form.$("expected_voucher_amount").value || 0
								)}
							</Typography>
						</Grid>
					</Grid>
				</Container>

				<Container maxWidth="lg" className="request_form_buttons" style={{marginTop: "15px"}}>
					<Grid item container spacing={1}>
						<Grid item>
							<XsButton
								variant="outlined"
								icon={<i className="fas fa-file-signature"></i>}
								text="Späť na zoznam"
								onClick={() => {
									RouterStore.push("/requests")
								}}
							/>
						</Grid>
						{RequestFormStore.requestInProgress && (
							<React.Fragment>
								<Grid item>
									<XsButton
										icon={<i className="fal fa-save"></i>}
										onClick={() => {
											// Nastavím pravidlá na nepovinné pre uloženie
											for (let i = 1; i <= 20; i++) {
												form.$(`rpo_search_${i}`).set("rules", "")
												form.$(`ownerName_${i}`).set("rules", "")
												form.$(`ownershipInterest_${i}`).set("rules", "")
											}
											form.$("round_id").set("rules", "")
											form.$("status").value = "inp"
											ConsentDialogStore.open()
											// delayedCallback(300, () => {
											// 	form.onSubmit(e)
											// })
										}}
										disableTextTransform
										text="ULOŽIŤ ROZPRACOVANÚ ŽIADOSŤ"
									/>
								</Grid>
								<Grid item>
									<XsButton
										icon={<i className="fal fa-paper-plane"></i>}
										className="xs-success"
										onClick={() => {
											// Obnovím pravidlá na povinné pre odoslanie podľa ownerType_
											const numberOfOwners = form.$("numberOfOwners").value || 0
											for (let i = 1; i <= 20; i++) {
												if (i <= numberOfOwners) {
													const ownerType = form.$(`ownerType_${i}`).value
													form.$(`ownershipInterest_${i}`).set("rules", "required")

													if (ownerType === "naturalPerson") {
														form.$(`ownerName_${i}`).set("rules", "required")
														form.$(`rpo_search_${i}`).set("rules", "")
													} else {
														form.$(`rpo_search_${i}`).set("rules", "required")
														form.$(`ownerName_${i}`).set("rules", "")
													}
												} else {
													form.$(`rpo_search_${i}`).set("rules", "")
													form.$(`ownerName_${i}`).set("rules", "")
													form.$(`ownershipInterest_${i}`).set("rules", "")
												}
											}
											form.$("round_id").set("rules", "required")
											form.$("status").value = "sent"
											ConsentDialogStore.open()
										}}
										text="ODOSLAŤ ŽIADOSŤ O POUKÁŽKU"
									/>
								</Grid>
							</React.Fragment>
						)}
						{RequestFormStore.showEditButton && (
							<Grid item>
								<XsButton
									icon={<i className="fal fa-pencil-alt"></i>}
									onClick={() => {
										if (RequestFormStore.readonlyForm) {
											RequestFormStore.readonlyForm = false
										} else {
											RequestFormStore.dropedFiles0 = []
											RequestFormStore.dropedFiles1 = []
											RequestFormStore.dropedFiles2 = []
											RequestFormStore.dropedFiles3 = []
											RequestFormStore.dropedFiles4 = []
											RequestFormStore.dropedFiles5 = []
											RequestFormStore.dropedFiles6 = []
											RequestFormStore.loadCodelistAndForm(form, props.id)
											RequestFormStore.readonlyForm = true
										}
									}}
									text={RequestFormStore.readonlyForm ? "UPRAVIŤ" : "Zahodiť zmeny"}
								/>
							</Grid>
						)}
					</Grid>
				</Container>
			</Container>
			<DeviceDialog />
			{WarningDialogStore.isOpen && <WarningDialog />}
			<ConsentDialog requestForm={form} />
			<XsConfirmationDialog
				name="xsDeleteAttachmentFromDropzone"
				title={"Pozor"}
				text={"Naozaj chcete odstrániť prílohu?"}
				onConfirmation={() =>
					handleDropzoneDelete(
						GlobalStore.confirmationDialogParams.fileIndex,
						GlobalStore.confirmationDialogParams.dropzoneIndex,
						GlobalStore.confirmationDialogParams.template
					)
				}
			/>
			<XsConfirmationDialog
				name="xsCloseRequestForm"
				text="Naozaj chcete opustiť formulár a zahodť zmeny?"
				confirmBtn={{
					icon: <i className="fal fa-check" />,
					text: "Common.btn.yes"
				}}
				cancelBtn={{
					icon: <i className="fal fa-times" />,
					text: "Common.btn.no"
				}}
				onConfirmation={() => {
					form.reset()
					RouterStore.push("/requests")
				}}
			/>
		</React.Fragment>
	)
}

export default injectIntl(observer(RequestForm))

